import React from 'react';

class PasswordInput extends React.PureComponent {
  constructor(props) {
    super(props);

    this.togglePassword = this.togglePassword.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = {
      showPassword: false,
      value: this.props.value,
    };
  }

  togglePassword() {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  }

  onChange(event) {
    this.setState({
      value: event.target.value, // do not trim
    });
  }

  render() {
    return (
      <div className="atom passwordInput">
        <input
          type={this.state.showPassword ? 'text' : 'password'}
          name="password"
          required={true}
          value={this.state.value}
          onChange={this.onChange}
          placeholder={this.props.placeholder}
        />
        {this.state.value ? (
          <span onClick={this.togglePassword}>{this.state.showPassword ? 'Hide' : 'Show'}</span>
        ) : (
          false
        )}
      </div>
    );
  }
}

PasswordInput.defaultProps = {
  value: '',
  placeholder: 'Password',
};

export default PasswordInput;
